const defaultFontSize = 14;
const controlHeightLG = 40;
const defaultBorderRadius = 6;
const defaultBorderRadiusLG = 8;
const appFontFamily = 'var(--app-font-family)';

const themeGlobal = {
  token: {
    fontFamily: appFontFamily,
    fontSize: defaultFontSize,
    controlHeight: controlHeightLG,
    controlHeightLG: controlHeightLG,
    borderRadius: defaultBorderRadius,
    borderRadiusLG: defaultBorderRadiusLG,
  },
  components: {
    Menu: {
      itemMarginBlock: 7,
      itemMarginInline: 0,
      itemPaddingInline: 0,
      activeBarBorderWidth: 0,
    },
    Form: {
      itemMarginBottom: 15,
    },
    Modal: {
      contentPadding: 10,
    },
    Card: {
      padding: 10,
      paddingLG: 15,
      boxShadow: 'none',
      borderRadiusLG: defaultBorderRadiusLG,
    },
    Tabs: {
      titleFontSizeLG: defaultFontSize,
    },
    Button: {
      fontSizeLG: defaultFontSize,
    },
    Input: {
      fontSizeLG: defaultFontSize,
      inputFontSizeLG: defaultFontSize,
      controlHeight: controlHeightLG,
      controlHeightLG: controlHeightLG,
      borderRadiusLG: defaultBorderRadius,
    },
    InputNumber: {
      fontSizeLG: defaultFontSize,
      controlHeightLG: controlHeightLG,
    },
    Tag: {
      fontSizeSM: defaultFontSize,
      lineHeightSM: 2.6666666666666665,
      borderRadiusSM: defaultBorderRadius,
    },
    DatePicker: {
      fontSizeLG: defaultFontSize,
      controlHeightLG: controlHeightLG,
      borderRadiusLG: defaultBorderRadius,
    },
    Select: {
      fontSizeLG: defaultFontSize,
      controlHeight: controlHeightLG,
      controlHeightLG: controlHeightLG,
      borderRadius: defaultBorderRadius,
      borderRadiusLG: defaultBorderRadius,
      singleItemHeightLG: controlHeightLG,
      showArrowPaddingInlineEnd: 30,
    },
    Segmented: {
      trackPadding: 2,
    },
    Dropdown: {
      borderRadiusLG: defaultBorderRadiusLG,
    },
    Divider: {
      fontSizeLG: defaultFontSize,
    },
    Table: {
      cellFontSize: 13,
      cellFontSizeMD: 13,
      cellFontSizeSM: 13,
      cellPaddingBlock: 10,
      cellPaddingInline: 12,
    },
  },
};

// Phones: 44px touch targets. App.js applies it in a nested ConfigProvider
// only on mobile, so desktop sizes stay as above.
const mobileControlHeight = 44;

export const themeMobile = {
  token: {
    controlHeight: mobileControlHeight,
  },
  components: {
    Input: {
      controlHeight: mobileControlHeight,
      controlHeightLG: mobileControlHeight,
    },
    InputNumber: {
      controlHeight: mobileControlHeight,
      controlHeightLG: mobileControlHeight,
    },
    Select: {
      controlHeight: mobileControlHeight,
      controlHeightLG: mobileControlHeight,
      singleItemHeightLG: mobileControlHeight,
    },
    DatePicker: {
      controlHeight: mobileControlHeight,
      controlHeightLG: mobileControlHeight,
    },
    // Items = control height - 2 x track padding (2) = 44px.
    Segmented: {
      controlHeight: mobileControlHeight + 4,
    },
  },
};

export default themeGlobal;
